<template>
  <div class='Box'>
    <el-card class="box-card">

      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
        <!-- <el-button size="medium" type="primary" @click="AddbusinessFlag">切换商务</el-button> -->
        <!-- <el-button size="medium" type="primary" icon="el-icon-upload2">导出</el-button> -->
<!--        <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <el-table
          ref="multipleTable"
          row-key="id"
          :data="tableData"
          tooltip-effect="dark"
          size="medium"
          :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          @selection-change="handleSelectionChange"
          border
          v-loading="loading"
      >
        <el-table-column type="selection" width="100">
        </el-table-column>
        <el-table-column label="标题" prop="title">
          <template slot-scope="scope">{{ scope.row.title }}</template>
        </el-table-column>
        <el-table-column prop="name" label="id">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>
        <el-table-column prop="url" label="规则"  >
          <template slot-scope="scope">{{ scope.row.url }}</template>
        </el-table-column>
        <el-table-column prop="weigh" label="权重">
          <!-- <template slot-scope="scope">{{ scope.row.weigh }}</template> -->
          <template slot-scope="scope">
            <el-tooltip placement="bottom" v-if="showWeight[scope.$index]">
              <div slot="content" v-html="clickText"></div>
              <span class="description-span" @click="setToNumber(scope.$index)">{{ scope.row.weigh }}</span>
            </el-tooltip>
            <el-input
            class="custom-input"
                v-if="!showWeight[scope.$index]"
                v-model="scope.row.weigh"
                @input="validateInput(scope.row)"
                @blur="editShowWeight(scope.$index)"
                @change="editWeight(scope.$index, scope.row)"
                style="width: 40%;"
                maxlength="5"
                v-focus
                :min="0"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 1">正常</el-tag>
            <el-tag type="danger" v-else>异常</el-tag>
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
            <el-button type="text" style="color: red"  size="medium" @click="handleDelete(scope.row)">删除</el-button>

          </template>

        </el-table-column>
      </el-table>

<!--      <business v-if="dialogVisible" :dialogVisible="dialogVisible" @busNone="busNone"></business>-->
      <AddVip v-if="vipFlag" :vipFlag="vipFlag" @NonevipFlag="NonevipFlag" @AddVipok="AddVipok" :editID="editID">
      </AddVip>
    </el-card>
  </div>
</template>

<script>

import business from "./component/business.vue"
import AddVip from "./component/AddVip.vue"
import {optimizationAPI} from "@/api/authRule/rule";
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {
    business,
    AddVip
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();  // 可选历史天、可选当前天、不可选未来天
        },
      },
      showWeight: {}, // 存储每一行的显示状态
      form: {
        name: ""
      },
      SearchFlag: false,
      queryParams: {
        pageNo: 1,
        pageSize: 9999,

      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "4"
      },

      tableData: [
      ],
      multipleSelection: [],
      dialogVisible: false,

      editID: "",
      // 总条数
      total: 0,
      vipFlag: false,
      loading: false,
      clickText:"点击编辑", 
    };
  },
  created() {
    this.getList()

  },
  methods: {
    getList() {
      this.loading = true
      let api = optimizationAPI()
      api.getRuleList(this.queryParams).then(res => {
        if (res.code == 0) {

          this.tableData =  this.buildTree(res.data.data)
        }else{
          processErrors(res);
        }
        this.loading = false
        for (let i = 0; i < this.total; i++) {
          this.$set(this.showWeight, i, true);
        }
      })
    },
    setToNumber(index) {
      for (let i = 0; i < this.total; i++) {
        this.$set(this.showWeight, i, true);
      }
      this.$set(this.showWeight, index, false); // 设置特定行的状态为 false
    },
    validateInput(row) {
      // 使用正则表达式验证输入值
      const regex = /^[0-9]*$/; // 只允许输入非负整数
      if (!regex.test(row.weigh)) {
        // 如果输入不符合要求，重置为0
        row.weigh = 0;
      }
    },

    editShowWeight(index) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 false
    },
    editWeight(index, data) {
      this.$set(this.showWeight, index, true); // 设置特定行的状态为 true
      if (data.weigh == null) {
        data.weigh = 0
      }
      let api = optimizationAPI()
      let params={...data}
      delete params.children;
      api.addAndEditRule(params).then(res => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: 'success'
          });
          this.$emit('AddOk');
          this.getList();
        } else {
          processErrors(res);
        }
      })
    },
    buildTree(data) {
      let tree = [];
      let lookup = {};

      data.forEach(item => {
        lookup[item.id] = {...item, children: []};
      });

      data.forEach(item => {
        if (item.pid === 0) {
          tree.push(lookup[item.id]);
        } else {
          if (lookup[item.pid]) {
            lookup[item.pid].children.push(lookup[item.id]);

          } else {
            tree.push(lookup[item.id]); // root elements with missing parent
          }
        }
      });

      return tree;
    },

    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleDelete(row){
      let api = optimizationAPI();
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.id
        }
        api.delRule(params).then(res => {
          if (res.code == 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList()

          } else {
            processErrors(res);
          }
        })
      }).catch(() => {
      });
    },
    addNoNe() {
      this.getList()
    },
    AddbusinessFlag() {
      this.dialogVisible = true
    },
    busNone() {
      this.dialogVisible = false
    },
    addList() {
      this.editID = ""
      this.vipFlag = true
    },
    NonevipFlag() {
      this.vipFlag = false
    },
    AddVipok() {
      this.getList()
      this.vipFlag = false
    },
    addEdit(row) {
      this.editID = row.id

      this.vipFlag = true
    }
  },
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted: function (el) {
        // 聚焦元素
        el.querySelector("input").focus();
      },
    },
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
  .custom-input ::v-deep .el-input__inner{
      text-align: center ;
      border: none ;
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>
